// List-query helpers matching the backend resource factory contract:
// GET /<resource>?page&pageSize&sort&order&search&<field>=a,b (arrays comma-joined).
export const DEFAULT_PAGE_SIZE = 20;

// Drops empty values; joins arrays to comma strings (server `in` filters).
// Caveat: a meaningful `false` must be pre-stringified ("false") by the caller.
export const collapseFilters = (filters = {}) => {
  const out = {};
  for (const [k, v] of Object.entries(filters)) {
    if (v === undefined || v === null || v === "" || v === false) continue;
    if (Array.isArray(v)) {
      if (v.length === 0) continue;
      out[k] = v.join(",");
    } else {
      out[k] = v;
    }
  }
  return out;
};

export const buildListQuery = (page, filters, opts = {}) => ({
  page,
  pageSize: opts.pageSize ?? DEFAULT_PAGE_SIZE,
  ...collapseFilters(filters),
});
